<script>import { twMerge } from 'tailwind-merge';
import { getContext } from 'svelte';
import { get_current_component } from 'svelte/internal';
import { forwardEventsBuilder, useActions } from '../../actions';
export let use = [];
import { exclude } from '../../utils/exclude';
const forwardEvents = forwardEventsBuilder(get_current_component());
const type = getContext('badge-type');
const defaultClass = '-ml-0.5 mr-1.5 h-2 w-2 stwui-badge-indicator';
const infoClass = 'text-info-content';
const successClass = 'text-success-content';
const warnClass = 'text-warn-content';
const errorClass = 'text-error-content';
$: finalClass = twMerge(defaultClass, type === 'info' ? infoClass : false, type === 'success' ? successClass : false, type === 'warn' ? warnClass : false, type === 'error' ? errorClass : false, $$props.class);
</script>

<svg
	class={finalClass}
	use:useActions={use}
	use:forwardEvents
	{...exclude($$props, ['use', 'class'])}
	fill="currentColor"
	viewBox="0 0 8 8"
>
	<circle cx="4" cy="4" r="3" />
</svg>
